/* tslint:disable */
/* eslint-disable */
/**
 * Jobs 24/7
 * Jobs 24/7
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: shraaliya0802@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CandidateContactRequest
 */
export interface CandidateContactRequest {
    /**
     * 
     * @type {string}
     * @memberof CandidateContactRequest
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateContactRequest
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateContactRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateContactRequest
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateContactRequest
     */
    subject?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateContactRequest
     */
    message?: string;
}

/**
 * Check if a given object implements the CandidateContactRequest interface.
 */
export function instanceOfCandidateContactRequest(value: object): value is CandidateContactRequest {
    return true;
}

export function CandidateContactRequestFromJSON(json: any): CandidateContactRequest {
    return CandidateContactRequestFromJSONTyped(json, false);
}

export function CandidateContactRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CandidateContactRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'subject': json['subject'] == null ? undefined : json['subject'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

  export function CandidateContactRequestToJSON(json: any): CandidateContactRequest {
      return CandidateContactRequestToJSONTyped(json, false);
  }

  export function CandidateContactRequestToJSONTyped(value?: CandidateContactRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'phone': value['phone'],
        'subject': value['subject'],
        'message': value['message'],
    };
}

